import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../../styles/notFound.css";
import { useTranslation } from "react-i18next";
export default function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useTranslation("portal");

  return (
    <div className="not-found">
      <h1 className="display-1 fw-bold">
        <i className="bi bi-emoji-smile"></i>
      </h1>
      <h2 className="fs-3 mb-4">{t('not_page')}</h2>
      <p className="text-muted mb-4">
        {t('not_exist')}
      </p>
      <Button
        variant="primary"
        size="lg"
        onClick={() => navigate("/home")}
        className="px-5"
      >
        {t('return_home')}
      </Button>
    </div>
  );
};
